export const parseExpenseDate = (val) => {
  if (!val) return null;
  if (val.toDate) return val.toDate();
  if (val instanceof Date) return Number.isNaN(val.getTime()) ? null : val;
  const normalized = String(val).includes('T') ? val : `${val}T00:00:00`;
  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const aggregateExpenses = (expenses = [], referenceDate = new Date()) => {
  const now = referenceDate;
  const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfTomorrow = new Date(startOfDay);
  startOfTomorrow.setDate(startOfTomorrow.getDate() + 1);

  const startOfWeek = new Date(startOfDay);
  startOfWeek.setDate(startOfDay.getDate() - 6);
  startOfWeek.setHours(0, 0, 0, 0);

  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const startOfYear = new Date(now.getFullYear(), 0, 1);
  const currentYear = now.getFullYear();

  const monthlyCounts = Array(12).fill(0);
  let totalAllTime = 0;
  let totalToday = 0;
  let totalWeek = 0;
  let totalMonth = 0;
  let totalYear = 0;

  expenses.forEach((expense) => {
    const expenseDate = parseExpenseDate(expense.expenseDate);
    const amount = parseFloat(expense.amount) || 0;
    if (!expenseDate || amount <= 0) return;

    totalAllTime += amount;

    if (expenseDate >= startOfDay && expenseDate < startOfTomorrow) {
      totalToday += amount;
    }
    if (expenseDate >= startOfWeek) {
      totalWeek += amount;
    }
    if (expenseDate >= startOfMonth) {
      totalMonth += amount;
    }
    if (expenseDate >= startOfYear) {
      totalYear += amount;
    }
    if (expenseDate.getFullYear() === currentYear) {
      monthlyCounts[expenseDate.getMonth()] += amount;
    }
  });

  return {
    totalAllTime: Number(totalAllTime.toFixed(2)),
    totalToday: Number(totalToday.toFixed(2)),
    totalWeek: Number(totalWeek.toFixed(2)),
    totalMonth: Number(totalMonth.toFixed(2)),
    totalYear: Number(totalYear.toFixed(2)),
    monthlyCounts: monthlyCounts.map((v) => Number(v.toFixed(2)))
  };
};

const roundMoney = (value) => Number((parseFloat(value) || 0).toFixed(2));

export const applyExpenseDeductionsToRevenueStats = (stats, expenseAgg) => ({
  ...stats,
  totalNetProfit: roundMoney(stats.totalNetProfit - expenseAgg.totalAllTime),
  potentialNetProfit: roundMoney(stats.potentialNetProfit - expenseAgg.totalAllTime),
  todayProfit: roundMoney(stats.todayProfit - expenseAgg.totalToday),
  thisWeekProfit: roundMoney(stats.thisWeekProfit - expenseAgg.totalWeek),
  thisMonthProfit: roundMoney(stats.thisMonthProfit - expenseAgg.totalMonth),
  thisYearProfit: roundMoney(stats.thisYearProfit - expenseAgg.totalYear),
  totalExpenses: expenseAgg.totalAllTime,
  thisMonthExpenses: expenseAgg.totalMonth
});

export const subtractExpensesFromMonthlyNetProfit = (monthlyNetProfitCounts, expenseMonthlyCounts) =>
  monthlyNetProfitCounts.map((profit, index) =>
    roundMoney(profit - (expenseMonthlyCounts[index] || 0))
  );
